export const iconData = [
  {
    id: 0,
    icon: "/images/jpg.svg",
    extension: "jpg",
  },
  {
    id: 1,
    icon: "/images/jpg.svg",
    extension: "JPG",
  },
  {
    id: 2,
    icon: "/images/jpg.svg",
    extension: "jpeg",
  },
  {
    id: 3,
    icon: "/images/jpg.svg",
    extension: "JPEG",
  },
  {
    id: 4,
    icon: "/images/xsl.svg",
    extension: "xlsx",
  },
  {
    id: 5,
    icon: "/images/xsl.svg",
    extension: "XLSX",
  },
  {
    id: 6,
    icon: "/images/xsl.svg",
    extension: "xls",
  },
  {
    id: 7,
    icon: "/images/xsl.svg",
    extension: "XLS",
  },
  {
    id: 8,
    icon: "/images/word_logo.png",
    extension: "doc",
  },
  {
    id: 9,
    icon: "/images/word_logo.png",
    extension: "DOC",
  },
  {
    id: 10,
    icon: "/images/word_logo.png",
    extension: "docx",
  },
  {
    id: 11,
    icon: "/images/word_logo.png",
    extension: "DOCX",
  },
  {
    id: 12,
    icon: "/images/pdf.png",
    extension: "pdf",
  },
  {
    id: 13,
    icon: "/images/pdf.png",
    extension: "PDF",
  },
  {
    id: 14,
    icon: "/images/png.png",
    extension: "png",
  },
  {
    id: 15,
    icon: "/images/png.png",
    extension: "PNG",
  },
  {
    id: 16,
    icon: "/images/mp3.svg",
    extension: "mp3",
  },
  {
    id: 17,
    icon: "/images/mp3.svg",
    extension: "MP3",
  },
  {
    id: 18,
    icon: "/images/mp4.svg",
    extension: "mp4",
  },
  {
    id: 19,
    icon: "/images/mp4.svg",
    extension: "MP4",
  },
  {
    id: 20,
    icon: "/images/ppt.svg",
    extension: "ppt",
  },
  {
    id: 21,
    icon: "/images/ppt.svg",
    extension: "pptx",
  },
  {
    id: 22,
    icon: "/images/link-icon.png",
    extension: "link",
  },
];
